import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { EventRoutingModule } from './event-routing.module'
import { TranslateModule } from '@ngx-translate/core'
import { CoreModule } from '../../core.module'
import { CustomTranslateModule } from '@flowaccount/landing'

import { DigitalAccountingConferenceComponent } from './digital-accounting-conference/digital-accounting-conference.component'
import { DacIntroComponent } from './digital-accounting-conference/dac-intro/dac-intro.component'
import { DacSpeakersComponent } from './digital-accounting-conference/dac-speakers/dac-speakers.component'
import { DacAgendaComponent } from './digital-accounting-conference/dac-agenda/dac-agenda.component'
import { DacHighlightComponent } from './digital-accounting-conference/dac-highlight/dac-highlight.component'
import { DacJobSuitableComponent } from './digital-accounting-conference/dac-job-suitable/dac-job-suitable.component'
import { DacVdoEventComponent } from './digital-accounting-conference/dac-vdo-event/dac-vdo-event.component'
import { DacStickyBannerComponent } from './digital-accounting-conference/dac-sticky-banner/dac-sticky-banner.component'

@NgModule({
  declarations: [
    DigitalAccountingConferenceComponent,
    DacIntroComponent,
    DacSpeakersComponent,
    DacAgendaComponent,
    DacHighlightComponent,
    DacJobSuitableComponent,
    DacVdoEventComponent,
    DacStickyBannerComponent,
  ],
  imports: [
    CommonModule,
    EventRoutingModule,
    TranslateModule,
    CoreModule.forRoot(),
    CustomTranslateModule.forChild({ path: 'event' }),
  ],
})
export class EventModule {}
